import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.JobFilterCountsRoot),
  () => import('./JobFilterCounts'),
  (JobFilterCounts) => {
    ComponentUtil.binder(Hooks.JobFilterCountsRoot, JobFilterCounts);
  },
);
